import React from 'react';
import Header from "../main-header/header";
import Footer from "../about/Footer";
import './gallery.css';

const galleryImages = [
  { src: 'images/right-image-black-big1.jpeg', alt: 'Concert Moment' },
  { src: 'images/right-small1.jpeg', alt: 'Shooting BTS' },
  { src: 'images/left-image-black1.jpeg', alt: 'Music Launch' },
  { src: 'images/left-image1.jpeg', alt: 'Red Carpet' },
  { src: '/images/right-image-black-small1.jpeg', alt: 'Film Screening' },
  { src: 'images/right-image-black-big1.jpeg', alt: 'Live Performance' },
];

export default function Gallery() {
  return (
    <div>
       <Header />
    <div className="gallery-page">
      <header className="gallery-header">
        <h1>VMAA Gallery</h1>
        <p>Memories from behind and beyond the scenes.</p>
      </header>

      <section className="gallery-grid">
        {galleryImages.map((item, index) => (
          <div className="gallery-card" key={index}>
            <img src={item.src} alt={item.alt} />
            <div className="overlay">
              <p>{item.alt}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
      <Footer />
    </div>
  );
}
